module.exports = "/lucky-balls/img/weager/Button.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Button.png
// module id = 1157
// module chunks = 0